// This file contains variables that define the fields that we request Vimeo
// to return in a response for a specific API type.
// See https://developer.vimeo.com/api/common-formats#json-filter.

/**
 * The fields that we want Vimeo to return when fetching Videos.
 */
export const videoFields = [
    "created_time",
    "description",
    "download",
    "duration",
    "embed",
    "link",
    "name",
    "password",
    "pictures",
    "player_embed_url",
    "privacy",
    "uri",
    "metadata",
].join(",");

export const rootFolderVideoFields = [
    "video.name",
    "video.description",
    "video.created_time",
    "video.duration",
    "video.embed",
    "video.link",
    "video.pictures",
    "video.download",
    "video.privacy",
    "video.player_embed_url",
    "video.uri",
    // As the name implies, this tells us
    // if an object is a video or a folder type.
    "type",
].join(",");
